import axios from 'axios'
import { TokenService } from '../services/storage.service'
import { UserService } from './user.service'
import { isObjectEquivalent, isGroupNotEqual, parseToken } from '@/utils/helper'
const qs = require('querystring')



const ApiService = {

  init (baseURL) {

    // let subscribers = []

    // function subscribeRetrievedToken(access_token) {
    //   subscribers = subscribers.filter(callback => callback(access_token))
    // }

    // function addSubscriber(callback) {
    //   subscribers.push(callback)
    // }

    axios.interceptors.response.use(function (response) {
      return response

    }, async function (error) {


      const { config, response: { status } } = error
      const previousRequest = config

      let _authorizing

      // if (status === 502) {
      //   window.location.href = process.env.VUE_APP_AZURE_AD_LOGOUT_URL + '=' + window.location.origin
      // } else 
      if (status == 504) {
        // this is more likely a timeout error in lambda, return 504 status code and handle error in the UI
        vm.$store.commit('user/requestOppreg/toggleManualRegOption', true)
        return status
      } else if (status >= 500) {
        vm.$store.commit('setServerError', "Galaxy encountered an error that prevent the request to complete. The 'Guardians' are working on this to resolve this issue." , { root: true })
        vm.$store.commit('user/requestOppreg/toggleManualRegOption', true)
        return
      } else if (status === 401) {
        console.log(previousRequest.url)
        // if (previousRequest.url.indexOf('verify-token') === -1 && previousRequest.url.indexOf('refresh-token') === -1) {
          console.log("Token has expired during submission.")
          await UserService.refreshToken()
          let access_token = TokenService.getIdToken()
          if (access_token) {
            // retry request except for verify and refresh token api
            if (previousRequest.url.indexOf('verify-token') === -1 && previousRequest.url.indexOf('refresh-token') === -1) {
              const retryOriginalRequest = new Promise((resolve) => {
                  previousRequest.headers.Authorization = 'Bearer ' + access_token
                  resolve(axios(previousRequest))
              })
              console.log('retrying original request' + previousRequest.url)
              return retryOriginalRequest
            } else {
              return true
            }
          }
      } else {
        console.log('other error')
        return { err: error }
        return Promise.resolve(error)

        // return error
      }
      console.log('401 error return')
    })

  },

  resetHeader: async function () {
    let header = await UserService.refreshToken()
    return header
  },
  
  setHeader (headers) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${TokenService.getToken()}`
    axios.defaults.headers.common['Content-Type'] = 'text/plain'
  },

  removeHeader (header) {
    if (header) {
      delete axios.defaults.headers.common[header]
    } else {
      axios.defaults.headers.common = {}
    }
  },

  get (resource, reqData = {}) {
    return axios.get(resource, reqData)
  },

  post (resource, body, reqData = {}) {
    return axios.post(resource, qs.stringify(body), reqData)
  },

  put (resource, body, reqData = {}) {
    if (body.ContentType) {
      this.removeHeader()
      let response = axios.put(
        resource, body.file,
        { headers: { 'Content-Type': body.ContentType } }
      )
      this.setHeader()
      return response
    }

    return axios.put(resource,
      qs.stringify(body),
      reqData
    )
  },

  delete (resource) {
    return axios.delete(resource)
  },

  customRequest (data) {
    console.log('customRequest')
    return axios(data)
  },

  // Stores the 401 interceptor position so that it can be later ejected when needed
  _401interceptor: null,

  mount401Interceptor () {
    console.log('mount401Interceptor')
    this._401interceptor = axios.interceptors.response.use(
      (response) => {
        return response
      },
      async (error) => {
        if (!error.response || error.request.status === 401 || error.request.status === 403) {
          if (error.config.url.includes('/o/token/')) {
            // Refresh token has failed. Logout the user
            vm.$store.dispatch('auth/logout')
            throw error
          } else {
            // Refresh the access token
            try {
              console.log('401 interceptor')

              await vm.$store.dispatch('auth/refreshToken')
              // Retry the original request
              return this.customRequest({
                method: error.config.method,
                url: error.config.url,
                data: error.config.data
              })
            } catch (e) {
              // Refresh has failed - reject the original request
              throw error
            }
          }
        }
        // If error was not 401 just reject as is
        throw error
      }
    )
  },

  unmount401Interceptor () {
    console.log('unmount401Interceptor')
    // Eject the interceptor
    axios.interceptors.response.eject(this._401interceptor)
  }
}

export default ApiService
